import { useEffect, useState } from 'react';
import { istTouchGeraet } from '../../lib/eingabeart';
import { useViewStore } from '../../stores/viewStore';

const TOUCH = istTouchGeraet();
/** So lange bleibt der Touch-Hinweis nach dem Eintritt in die Ego-Ansicht stehen. */
const HINWEIS_DAUER_MS = 4000;

/**
 * Kurzer Bedienhinweis der Ego-Ansicht. Mit Maus wichtig, weil sie gefangen
 * wird: ohne Escape kaeme man an Leiste, Chat und Modals nicht heran. Der
 * Hinweis verschwindet, sobald die Maus gefangen ist, und kommt zurueck,
 * wenn sie wieder frei ist. Mit Fingern gibt es nichts zu fangen — dort
 * steht das Fadenkreuz immer, und der Hinweis blendet sich nach kurzer Zeit aus.
 */
export function FirstPersonHint() {
  const mode = useViewStore((s) => s.mode);
  const [locked, setLocked] = useState(false);
  const [touchHinweis, setTouchHinweis] = useState(true);

  useEffect(() => {
    if (TOUCH) return;
    const onChange = (): void => setLocked(document.pointerLockElement !== null);
    onChange();
    document.addEventListener('pointerlockchange', onChange);
    return () => document.removeEventListener('pointerlockchange', onChange);
  }, []);

  useEffect(() => {
    if (!TOUCH || mode !== '3d') return;
    setTouchHinweis(true);
    const timer = window.setTimeout(() => setTouchHinweis(false), HINWEIS_DAUER_MS);
    return () => window.clearTimeout(timer);
  }, [mode]);

  if (mode !== '3d') return null;
  if (TOUCH) {
    return (
      <>
        <div className="office__crosshair" aria-hidden="true" />
        {touchHinweis && (
          <div className="office__fp-hint" role="status">
            <strong>Links</strong> laufen, weit über den Ring rennen · <strong>rechts</strong> umsehen · <strong>Tippen</strong> benutzt
          </div>
        )}
      </>
    );
  }
  return (
    <>
      {/* Fadenkreuz: zeigt, worauf man zielt (Leertaste oeffnet das Objekt) */}
      {locked && <div className="office__crosshair" aria-hidden="true" />}
      {!locked && (
        <div className="office__fp-hint" role="status">
          <strong>Klicken</strong> fängt die Maus ein · <strong>WASD</strong> laufen · <strong>Umschalt</strong> rennt · <strong>Q/E</strong> drehen ·{' '}
          <strong>Leertaste</strong> benutzt und setzt sich · <strong>Esc</strong> gibt die Maus wieder frei
        </div>
      )}
    </>
  );
}
